// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  padding: 20px 20px 20px 20px;
  margin-top: 20px;
}

.cardTitle {
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
}

.content {
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
}

.sub-content {
  padding: 10px 0px 15px 0px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
}

.table {
  padding: 10px 10px 10px 10px;
}

.table thead th {
  font-weight: 400;
}

.table-header {
  border-bottom: 2px solid var(--color-primary);
  font-style: normal;
  font-size: 14px;
}

.table-content {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
}`, "",{"version":3,"sources":["webpack://./ClientApp/src/app/desktop/d-landing-page/cancelorder/cancelorder.component.scss"],"names":[],"mappings":"AAAA;EAEE,4BAAA;EACA,gBAAA;AAAF;;AAGA;EAEE,kBAAA;EACA,gBAAA;EACA,eAAA;AADF;;AAKA;EAEE,kBAAA;EACA,gBAAA;EACA,eAAA;AAHF;;AAMA;EAEE,0BAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAJF;;AAOA;EAEE,4BAAA;AALF;;AAQA;EAEE,gBAAA;AANF;;AASA;EAEI,6CAAA;EACA,kBAAA;EACA,eAAA;AAPJ;;AAUA;EAEE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AARF","sourcesContent":[".card\n{\n  padding: 20px 20px 20px 20px;\n  margin-top: 20px;\n}\n\n.cardTitle\n{\n  font-style: normal;\n  font-weight: 600;\n  font-size: 18px;\n}\n\n\n.content\n{\n  font-style: normal;\n  font-weight: 600;\n  font-size: 18px;\n}\n\n.sub-content\n{\n  padding: 10px 0px 15px 0px;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n}\n\n.table\n{\n  padding: 10px 10px 10px 10px;\n}\n\n.table thead th\n{\n  font-weight: 400;\n}\n\n.table-header \n{\n    border-bottom: 2px solid var(--color-primary);\n    font-style: normal;\n    font-size: 14px;\n}\n\n.table-content\n{\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
